/**
 * Por qué se cayó la casilla de una campaña, para leer en un aviso (change
 * campanas-casilla-de-envio). Espejo de `motivoDeCasilla` en
 * `supabase/functions/_shared/notification-labels.ts`: Deno no importa el
 * frontend. Los motivos los escribe `core.pausar_campana_por_casilla`.
 */
export function motivoDeCasilla(motivo: string | null | undefined): string {
  switch (motivo) {
    case 'revocada':
      return 'está desconectada';
    case 'autorizacion_vencida':
      return 'perdió la autorización';
    case 'sin_casilla':
      return 'no está conectada';
    default:
      return 'está apagada';
  }
}
